module.exports = __webpack_public_path__ + "static/img/1383_phase_function_Paper_Points.f207537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1383_phase_function_Paper_Points.png
// module id = vPgF
// module chunks = 0